import { FilterOptionDto } from '@act/shared/data-transfer-objects';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

type ControlledRadioSelectProps<
  TFieldValues extends FieldValues = FieldValues,
> = {
  name: Path<TFieldValues>;
  label: string;
  row?: boolean;
  control: Control<TFieldValues>;
  options: FilterOptionDto[];
  getOptionLabel: (TFieldValue) => string;
  multiple?: boolean;
  limitTags?: number;
};

const ControlledRadioSelect = function <T>({
  name,
  control,
  options,
  row,
}: ControlledRadioSelectProps<T>) {
  function handleChange(event, currentValue, onChange) {
    const clickedValue = event.target.value;
    if (clickedValue === currentValue) {
      onChange(null);
    } else {
      onChange(clickedValue);
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <RadioGroup
            row={row}
            defaultValue={undefined}
            value={value}
            onChange={(event, data) => handleChange(event, value, onChange)}
          >
            {options.map(option => {
              return (
                <FormControlLabel
                  key={`option-${option.value}`}
                  label={option.label}
                  value={option.value}
                  control={
                    <Radio
                      onClick={event => handleChange(event, value, onChange)}
                    />
                  }
                />
              );
            })}
          </RadioGroup>
        );
      }}
    />
  );
};

export default ControlledRadioSelect;
